import Modal from "react-bootstrap/Modal";
import "../style/rightside.css";
import { currencies } from "../constants/currency";
import { useEffect, useState } from "react";
import nigeria from "../asset/images/countries/ngn.svg";
import axios from "axios";
import Loader from "./loader";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FailHandler from "./failhandler";
import SuccessHolder from "./SuccessHolder";
import RecordedTransaction from "./RecordedTransaction";

const RecordPaymentTransactionForm = (props) => {
    const [showdrop, setisshowdrop] = useState(false);
    const [selectedcurrency, setselectedcurrency] = useState([]);
    const [added, setadded] = useState(false);
    const [date, setDate] = useState("");
    const [amount, setamount] = useState("");
    const [selectedtransaction] = useState();

    const [isdisabled, setisdisable] = useState(true);
    const [isalldatafilledandclick] = useState(false);
    const [loader, setloader] = useState(false);
    const [message, setmessage] = useState("");
    const [fails, setfails] = useState(false);
    const [success, setsuccess] = useState(false);
    const [setTransaction] = useState("");
    const [showtranst, setshowtransact] = useState(false);
    const [eachTransaction, setEachTransaction] = useState([]);

    const { tenure, setSelectedMethod } = props; 

    const today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        if ((amount !== "" && date) || eachTransaction) {
            setisdisable(false);
        } else {
            setisdisable(true);
        }
    }, [amount, date, setisdisable]);
    useEffect(() => {
        if (fails) {
            let timer = setTimeout(() => {
                setfails(false);
            }, 3000);

            return () => {
                clearTimeout(timer);
            };
        }
        if (success) {
            let timer = setTimeout(() => {
                setsuccess(false);
                props.setshow(false);
            }, 3000);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [fails, success]);
    const handlesubmit = async (e) => {
        e.preventDefault();
        setloader(true);
        if (props.selectedmethods === "Cash") {
            const data = {
                amount: amount,
                currency: selectedcurrency.length === 0 ? "NGN" : selectedcurrency.title,
                paymentMethod: props.selectedmethods,
                paymentDate: date,
            };
            await axios
                .post(`/v1/invoice/pay/${props.selectedinvoice._id}`, data)
                .then((res) => {
                    //console.log(res);
                    setloader(false);
                    setsuccess(true);
                    setmessage(res.data.message);
                    setfails(false);
                    props.setinvoices([...props.record, data]);
                })
                .catch((e) => {
                    setloader(false);
                    setsuccess(false);
                    setfails(true);

                    setmessage(e.response.data ? e.response.data.message : "An error occurred");
                });
        } else {
            const data = {
                amount: eachTransaction?.totalAmount
                    ? eachTransaction?.totalAmount?.toString()
                    : eachTransaction?.amount?.toString(),
                currency: eachTransaction?.currency,

                paymentMethod: props.selectedmethods,
                paymentDate: eachTransaction?.createdAt,
            };
            await axios
                .post(`/v1/invoice/pay/${props.selectedinvoice._id}`, data)
                .then((res) => {
                    setloader(false);
                    setsuccess(true);
                    setmessage(res.data.message);
                    setfails(false);
                    props.setinvoices([...props.record, data]);
                })
                .catch((e) => {
                    setloader(false);
                    setsuccess(false);
                    setfails(true);
                    setmessage(e.response.data ? e.response.data.message : "An error occurred");
                });
        }
    };

    return (
        <>
            <RecordedTransaction
                show={showtranst}
                setshow={setshowtransact}
                setEachTransaction={setEachTransaction}
                currency={props.currency}
            />
            <Modal
                show={props.show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="addpaymentmodal"
                onHide={() => props.setshow(false)}
            >
                <Modal.Header>
                    <span
                        className="material-icons"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            props.setshow(false);
                        }}
                    >
                        close
                    </span>
                </Modal.Header>
                <Modal.Body className="border-0 ">
                    <form onSubmit={handlesubmit}>
                        <div className="relative flex flex-col gap-8">
                            <FailHandler message={message} success={fails} />
                            <SuccessHolder message={message} success={success} />
                            <h4 class="text-[#101828] font-semibold text-lg leading-[24.3px]">
                                Record a new payment
                            </h4>
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-4">
                                    <div class="h-14 rounded-lg bg-[#ECEFF3] p-2.5 px-4">
                                        <div class="flex flex-col gap-2">
                                            <label
                                                htmlFor="Method of payment"
                                                class="text-[#667085] text-[12px] leading-[16.2px] font-normal tracking-wider"
                                            >
                                                Method of payment
                                            </label>
                                            <select
                                                value={props.selectedmethods}
                                                onChange={(e) => setSelectedMethod(e.target.value)}
                                                className="!shadow-none outline-none border-0 bg-[#ECEFF3] text-[#101828] tracking-[2%] leading-6 text-[16px] font-normal"
                                            >
                                                {tenure.map((method, index) => (
                                                    <option value={method} key={index}>{method}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    {isalldatafilledandclick === false &&
                                        props.selectedmethods === "Cash" && (
                                            <div className="flex gap-2">
                                                <div
                                                    className="w-full max-w-[96px] rounded-[8px] border-0 outline-none bg-[#ECEFF3] py-2 px-2 tracking-[2%] font-normal text-[16px] flex gap-2 items-center relative"
                                                    onClick={() => {
                                                        setisshowdrop(!showdrop);
                                                    }}
                                                >
                                                    {" "}
                                                    {showdrop === true && (
                                                        <div className="absolute bg-white p-2 w-full top-10 -left-2 rounded-[4px] z-10">
                                                            <div className="flex flex-col gap-4">
                                                                {" "}
                                                                {currencies.map(
                                                                    (currency, index) => (
                                                                        <div
                                                                            className="flex gap-8 leading-5 cursor-pointer"
                                                                            key={index}
                                                                            onClick={() => {
                                                                                setselectedcurrency(
                                                                                    currency
                                                                                );
                                                                                setadded(true);
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={currency.image}
                                                                                alt=""
                                                                                height={24}
                                                                                width={24}
                                                                            />
                                                                            <span className="text-gray-500 tracking-[2%] leading-6 text-base">
                                                                                {" "}
                                                                                {currency.title}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                )}{" "}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <img
                                                        src={
                                                            added ? selectedcurrency.image : nigeria
                                                        }
                                                        alt=""
                                                        height={24}
                                                        width={24}
                                                    />
                                                    <span className="text-[#667085] tracking-[2%] leading-6 text-[16px]">
                                                        {" "}
                                                        {added === true
                                                            ? selectedcurrency.title
                                                            : "NGN"}
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        height: "56px",
                                                        borderRadius: "8px",
                                                        background: "#ECEFF3",
                                                        padding: "8px 16px 8px 16px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <div className="flex flex-col gap-2">
                                                        <label
                                                            htmlFor="Method of payment"
                                                            className="text-[#667085] text-xs leading-5 font-normal tracking-[2%]"
                                                        >
                                                            Amount
                                                        </label>
                                                        <input
                                                            name=""
                                                            id=""
                                                            onChange={(e) => {
                                                                setamount(e.target.value);
                                                            }}
                                                            className="!shadow-none outline-none border-none bg-[#ECEFF3] text-[#101828] tracking-[2%] leading-6 text-base font-normal mt-[-5px]"
                                                            placeholder="50000"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {isalldatafilledandclick === false &&
                                        props.selectedmethods === "Cash" && (
                                            <div className="h-14 rounded-lg bg-[#ECEFF3] px-4 py-2">
                                                <div className="flex flex-col gap-2">
                                                    <label
                                                        htmlFor="Method of payment"
                                                        className="text-[#667085] text-xs leading-[16.2px] font-normal tracking-[2%]"
                                                    >
                                                        Payment Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        name=""
                                                        id=""
                                                        value={date}
                                                        onChange={(e) => setDate(e.target.value)}
                                                        max={today}
                                                        className="!shadow-none outline-none border-0 bg-[#ECEFF3] text-[#101828] tracking-[2%] leading-6 text-[16px] font-normal overflow-hidden box-border -mt-5"
                                                        placeholder="May 5, 2021"
                                                    />
                                                </div>
                                            </div>
                                        )}{" "}
                                </div>
                                {isalldatafilledandclick === false &&
                                    props.selectedmethods !== "Cash" && (
                                        <div className="h-14 rounded-lg bg-[#ECEFF3] px-4 py-2 flex items-center">
                                            <div
                                                className="flex items-center w-full gap-2"
                                                onClick={() => setshowtransact(true)}
                                            >
                                                <input
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    readOnly
                                                    value={eachTransaction?.accountName}
                                                    onChange={(e) => {
                                                        setTransaction(e.target.value);
                                                    }}
                                                    className="!shadow-none outline-none border-0 bg-[#ECEFF3] text-[#101828] tracking-[2%] leading-6 text-[16px] font-normal overflow-hidden box-border w-full"
                                                    placeholder="Link with a transaction"
                                                />
                                            </div>
                                        </div>
                                    )}{" "}
                            </div>
                            <button
                                type="submit"
                                disabled={isdisabled}
                                className="bg-[#6F00FF] p-4 gap-8 h-12 outline-none border-0 rounded-[8px] text-white text-center text-base leading-6 tracking-[2%] font-medium justify-center items-center flex"
                            >
                                {loader ? <Loader /> : " Record payment"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default RecordPaymentTransactionForm;
